var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14639_78162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.2969 30.9375H25.4688C26.1159 30.9375 26.6406 31.4622 26.6406 32.1094C26.6406 32.7566 26.1159 33.2812 25.4688 33.2812H24.2969V40H30.5469V26.25H24.2969V30.9375Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.45312 26.25H16.4844V30.9375H9.45312V26.25Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.17969 20.0781C6.44492 20.0781 8.28125 18.2418 8.28125 15.9766V15H0.078125V15.9766C0.078125 18.2418 1.91445 20.0781 4.17969 20.0781Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1719 15.9766C21.1719 18.2418 23.0082 20.0781 25.2734 20.0781C27.5387 20.0781 29.375 18.2418 29.375 15.9766V15H21.1719V15.9766Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625 15.9766C10.625 18.2418 12.4613 20.0781 14.7266 20.0781C16.9918 20.0781 18.8281 18.2418 18.8281 15.9766V15H10.625V15.9766Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5469 19.6756C29.3796 21.3347 27.4516 22.4219 25.2734 22.4219C23.0952 22.4219 21.1673 21.3347 20 19.6756C18.8327 21.3347 16.9048 22.4219 14.7266 22.4219C12.5484 22.4219 10.6204 21.3347 9.45312 19.6756C8.28586 21.3347 6.35789 22.4219 4.17969 22.4219C3.27852 22.4219 2.42023 22.2353 1.64062 21.8998V38.8281C1.64062 39.4753 2.16531 40 2.8125 40H21.9531V25.0781C21.9531 24.4309 22.4778 23.9063 23.125 23.9063H31.7188C32.3659 23.9063 32.8906 24.4309 32.8906 25.0781V40H37.1875C37.8347 40 38.3594 39.4753 38.3594 38.8281V21.8998C37.5798 22.2352 36.7215 22.4219 35.8203 22.4219C33.6421 22.4219 31.7141 21.3347 30.5469 19.6756ZM18.8281 32.1094C18.8281 32.7566 18.3034 33.2813 17.6562 33.2813H8.28125C7.63406 33.2813 7.10938 32.7566 7.10938 32.1094V25.0781C7.10938 24.4309 7.63406 23.9063 8.28125 23.9063H17.6562C18.3034 23.9063 18.8281 24.4309 18.8281 25.0781V32.1094Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7188 15V15.9766C31.7188 18.2418 33.5551 20.0781 35.8203 20.0781C38.0855 20.0781 39.9219 18.2418 39.9219 15.9766V15H31.7188Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1719 6.79688V12.6562H29.1649L27.3745 6.79688H21.1719Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.828 12.6562V6.79688H12.6254L10.835 12.6562H18.828Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1747 6.79688H4.17355L0.592773 12.6562H8.38441L10.1747 6.79688Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6156 12.6562H39.407L35.8263 6.79688H29.8252L31.6156 12.6562Z",
    fill: "#E66100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.625 1.17188C35.625 0.524687 35.1003 0 34.4531 0H5.54688C4.89969 0 4.375 0.524687 4.375 1.17188V4.45312H35.625V1.17188Z",
    fill: "#E66100"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14639_78162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/Shop.e6cdf86a3f282e17cda5266e5fcbc789.svg";
export { ForwardRef as ReactComponent };